<template>

        
        <!-- INICIO ACCORDION -->
        <div class="accordion" id="accordion">

            <!-- INICIO ITEM COLLAPSE -->
            <item 
                v-for="(op, index) in operacoes" 
                :key="index" 
                :index="index" 
                :item="op"
            />
            <!-- FINAL ITEM COLLAPSE -->

        </div>
        <!-- FINAL ACCORDION -->
</template>

<script>
    import ListaItem from './WalletExtratoListaItem.vue';

    export default {
        props: {
            operacoes: {type: Array}
        },

        components: {
            'item': ListaItem,
        },

        methods: {
            // async AbrirCollapse(id) {
            //     // 		// função de ajuste emergencial no css
            //     // 		isAbrir ? document.querySelector('.main-content').style.zIndex = 10 : document.querySelector('.main-content').style.zIndex = 2

            //     // 		if (document.getElementsByTagName("main").length > 0) {
            //     // 			if (isAbrir) document.getElementsByTagName("main")[0].style.zIndex = "50";
            //     // 			else document.getElementsByTagName("main")[0].style.zIndex = "0";
            //     // 		}

            //     //         this.showModal = isAbrir;

            //     //   let el = document.getElementById(`collapse${id}`);

            //     //   let classAct = el.classList.contains('collapse.show');

            //     //   if(classAct) el.classList.remove('collapse.show');

            //     //   else el.classList.add('collapse.show');

            //     let detalhesOperacao;

            //     $(".collapse").collapse("hide");
            //     $(".active").removeClass("active");
            //     $(`#collapse${id}`).collapse("toggle");

            //     if(id != this.lastID) {

            //         $(`#collapseLink${id}`).addClass("active");

            //         this.operacoes[id].loadingInformation = true;
            //         detalhesOperacao = await ApiClient.getCarteiraItem(this.operacoes[id].id);
            //         this.operacoes[id].loadingInformation = false;
            //         this.operacoes[id].Detalhes.Pagamento = detalhesOperacao.data.Detalhes.Pagamento;

            //         this.lastID = id;

            //     }


                
            // },
        }
    }
</script>

<style lang="scss">
    .date {
        text-transform: uppercase;
        width: 4em !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/Wallet/WalletExtratoLista.vue